import he from "he";

const groupedNumber = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });

export const toNumber = (value) => (Number.isFinite(Number(value)) ? Number(value) : 0);

export const money = (value) => `৳${groupedNumber.format(Math.round(toNumber(value)))}`;

/** Lakh / crore short form - the units this business actually reads in. */
export const moneyShort = (value) => {
  const amount = toNumber(value);
  const sign = amount < 0 ? "-" : "";
  const abs = Math.abs(amount);
  const trim = (n, unit) => `${sign}৳${String(Number(n.toFixed(2)))}${unit}`;

  if (abs >= 1e7) return trim(abs / 1e7, " Cr");
  if (abs >= 1e5) return trim(abs / 1e5, " L");
  if (abs >= 1e3) return trim(abs / 1e3, "K");
  return `${sign}৳${groupedNumber.format(Math.round(abs))}`;
};

export const count = (value) => groupedNumber.format(Math.round(toNumber(value)));

export const percent = (value) => {
  if (!Number.isFinite(value)) return "0%";
  if (value > 0 && value < 0.1) return "<0.1%";
  return `${value.toFixed(1).replace(/\.0$/, "")}%`;
};

export const share = (part, whole) => (whole > 0 ? (part / whole) * 100 : 0);

/* ------------------------------------------------------------------- dates --
 * Dates travel as local calendar days ("YYYY-MM-DD"). Never use toISOString():
 * it converts to UTC, which in Dhaka (UTC+6) shifts local midnight to the
 * previous day.
 * -------------------------------------------------------------------------- */

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const toISODate = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

/** Parses "YYYY-MM-DD" as a local date; returns null for anything invalid. */
export const parseISODate = (value) => {
  if (typeof value !== "string" || !ISO_DATE.test(value)) return null;
  const [y, m, d] = value.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  // Rejects roll-overs such as 2026-02-31.
  return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d ? date : null;
};

export const addDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export const prettyDate = (value) => {
  if (!value) return "-";
  const date = parseISODate(String(value).slice(0, 10));
  if (!date) return String(value);
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const prettyTime = (date) => date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });

/** Names arrive HTML-escaped from the legacy import ("M/S Rahim &amp; Co"). */
export const clean = (value) => {
  if (!value) return "";
  try {
    return he.decode(String(value));
  } catch (error) {
    return String(value);
  }
};

export const truncate = (text, max) => (text.length > max ? `${text.slice(0, max - 1)}…` : text);
